import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { handleEditItem } from '../utils/crmActions';

const EditPaymentModal = ({ payment, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    amount: '',
    method: 'cash',
    reference: '',
    paymentDate: ''
  });

  useEffect(() => {
    if (payment) {
      setForm({
        amount: payment.amount,
        method: payment.method,
        reference: payment.reference || '',
        paymentDate: payment.paymentDate ? payment.paymentDate.substr(0, 10) : ''
      });
    }
  }, [payment]);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = { ...form };
    await handleEditItem('payments', payment._id, payload, onSuccess, onClose);
  };

  if (!payment) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md p-6 rounded shadow">
        <h2 className="text-lg font-bold mb-4">Edit Payment</h2>

        <label className="text-sm text-gray-600">Amount</label>
        <input
          type="number"
          className="w-full mb-3 border rounded px-2 py-1"
          value={form.amount}
          onChange={(e) => handleChange('amount', parseFloat(e.target.value) || 0)}
        />

        <label className="text-sm text-gray-600">Method</label>
        <select
          className="w-full mb-3 border rounded px-2 py-1"
          value={form.method}
          onChange={(e) => handleChange('method', e.target.value)}
        >
          <option value="cash">Cash</option>
          <option value="credit_card">Credit Card</option>
          <option value="paypal">PayPal</option>
          <option value="bank_transfer">Bank Transfer</option>
        </select>

        <label className="text-sm text-gray-600">Reference</label>
        <input
          type="text"
          className="w-full mb-3 border rounded px-2 py-1"
          value={form.reference}
          onChange={(e) => handleChange('reference', e.target.value)}
        />

        <label className="text-sm text-gray-600">Date</label>
        <input
          type="date"
          className="w-full mb-4 border rounded px-2 py-1"
          value={form.paymentDate}
          onChange={(e) => handleChange('paymentDate', e.target.value)}
        />

        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
          <button onClick={handleSubmit} className="px-4 py-2 bg-blue-600 text-white rounded">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPaymentModal;
